import { Link } from "react-router-dom";

const ServiceSuggestion = () => {
    return (
        <>
            {/* Service Suggestion */}
            <div className="bg-blue-50 border border-blue-100 rounded-lg p-4">
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                    <div>
                        <h3 className="font-medium text-blue-800 mb-1">هل تحتاج إلى خدمات إضافية؟</h3>
                        <p className="text-blue-600 text-sm">
                            نوفر خدمات النقل والتخزين بجودة عالية وأسعار تنافسية
                        </p>
                    </div>
                    <Link
                        to="/home/services"
                        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors"
                    >
                        تصفح الخدمات المتاحة
                    </Link>
                </div>
            </div>
        </>
    );
}

export default ServiceSuggestion;